import { useI18n } from "@/composables/useI18n";
import { computed } from "vue";

/** Withdrawn ISO 3166 aliases and CLDR macro-regions / pseudo-regions that are not countries. */
const obsoleteIsoCountryCodes = new Set([
  "EU",
  "EZ",
  "QO",
  "UN",
  "XA",
  "XB",
  "ZZ",
  "AN",
  "BU",
  "CS",
  "DD",
  "DY",
  "FX",
  "HV",
  "NH",
  "RH",
  "SU",
  "TP",
  "UK",
  "VD",
  "YD",
  "YU",
  "ZR",
]);

export const useIsoCountryItems = () => {
  const { locale } = useI18n();
  const isoCountryItems = computed(() => {
    const displayNames = new Intl.DisplayNames([locale.value], { type: "region" });
    const items: { title: string; value: string }[] = [];
    const seenTitles = new Set<string>();
    for (let first = 65; first <= 90; first++) {
      for (let second = 65; second <= 90; second++) {
        const code = String.fromCharCode(first, second);
        if (obsoleteIsoCountryCodes.has(code)) continue;
        const title = displayNames.of(code);
        if (!title || title === code || seenTitles.has(title)) continue;
        seenTitles.add(title);
        items.push({ title, value: code });
      }
    }
    return items.sort((a, b) => a.title.localeCompare(b.title));
  });
  return { isoCountryItems };
};
